import { render, staticRenderFns } from "./DispatchSearchFilter.vue?vue&type=template&id=0f5a8a45&scoped=true"
import script from "./DispatchSearchFilter.vue?vue&type=script&lang=js"
export * from "./DispatchSearchFilter.vue?vue&type=script&lang=js"
import style0 from "./DispatchSearchFilter.vue?vue&type=style&index=0&id=0f5a8a45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5a8a45",
  null
  
)

export default component.exports